import { CARD_ERRORS } from 'shared/constants/GenericMessages';
import { validateTarjeta } from 'shared/form/validations/ValidateTarjeta';
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FormWithValidation } from 'shared/form';

export const SearchCardAuthorizationForm = (props: {
  cardNumber: string;
  searchCardNumber(data): void;
}) => {
  const searchTarjeta = (data) => {
    props.searchCardNumber(data);
  };

  return (
    <Card>
      <Card.Header className="text-center">Autorizaciones por Tarjeta</Card.Header>
      <Card.Body>
        <Alert>
          Estos movimientos corresponden a consumos autorizados pendientes de presentación
          por parte del establecimiento. Los mismos se consideran para calcular el
          disponible de la tarjeta.
        </Alert>
        <FormWithValidation
          onSubmit={searchTarjeta}
          formProps={{
            defaultValues: {
              tarjeta: props.cardNumber,
            },
          }}
        >
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
              Nro. Tarjeta
            </Form.Label>
            <Col sm="9">
              <FormWithValidation.Control
                type="text"
                autoComplete="tarjeta"
                data-testid="tarjeta-input"
                name="tarjeta"
                registerOptions={{
                  required: CARD_ERRORS.cardNumberRequired,
                  validate: (text: string) =>
                    validateTarjeta(text) || CARD_ERRORS.cardNumberInvalid,
                }}
              />
              <FormWithValidation.Control.Feedback type="invalid" controlId="tarjeta" />
            </Col>
          </Form.Group>
          <Button type="submit">Consultar</Button>
        </FormWithValidation>
      </Card.Body>
    </Card>
  );
};
